import { getToken } from "src/redux/selectors";

export function addSpecial(values, activateDisplayId) {
  if (activateDisplayId) {
    values.activateDisplayId = true;
  }
  return dispatch =>
    new Promise((resolve, reject) => {
      return fetch(
        process.env.REACT_APP_GLOBAL_SERVER + "sproutmanagement/api/special/addspecial",
        {
          method: "POST",
          mode: "cors",
          headers: {
            Authorization: "Bearer " + getToken(),
            "Content-Type": "application/json; charset=utf-8",
          },
          body: JSON.stringify(values),
        }
      ).then(async res => {
        if (!res.ok) {
          return reject({ message: "Failed to add special" });
        }
        return resolve(await res.text());
      });
    }).catch(err => {
      throw err.message;
    });
}

export function deleteSpecial(id) {
  return dispatch =>
    new Promise((resolve, reject) => {
      return fetch(
        process.env.REACT_APP_GLOBAL_SERVER + "sproutmanagement/api/special/deletespecial",
        {
          method: "POST",
          mode: "cors",
          headers: {
            Authorization: "Bearer " + getToken(),
            "Content-Type": "application/json; charset=utf-8",
          },
          body: JSON.stringify({ id: id }),
        }
      )
        .then(res => {
          if (!res.ok) {
            return reject({ message: "Failed to delete special" });
          }
          res.text();
        })
        .catch(async error => {
          return reject(error);
        })
        .then(async response => {
          try {
            return resolve({ message: response });
          } catch (e) {
            return reject({ message: response });
          }
        });
    }).catch(err => {
      throw err.message;
    });
}

export function findAllSpecial(access, year, months = []) {
  const baseUrl = process.env.REACT_APP_GLOBAL_SERVER + "sproutmanagement/api/special/findallspecial";

  const query = new URLSearchParams();
  if (access) query.append("access", access);
  if (year) query.append("year", year);
  const normalizedMonths = Array.isArray(months) ? months : [months];
  if (normalizedMonths.length > 0) {
    query.append("months", normalizedMonths.join(","));
  }


  const url = `${baseUrl}?${query.toString()}`;

  return dispatch =>
    new Promise((resolve, reject) => {
      fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          Authorization: "Bearer " + getToken(),
          "Content-Type": "application/json; charset=utf-8",
        },
      })
        .then(async res => {
          if (!res.ok) return reject({ message: await res.text() });

          return resolve(
            dispatch({
              type: "SPECIAL_FIND_ALLSPECIAL",
              data: await res.json(),
            })
          );
        })
        .catch(err => {
          throw err.message;
        });
    });
}


export function setEditSpecial(special) {
  return dispatch =>
    dispatch({
      type: "SPECIAL_SET_EDITSPECIAL",
      data: special,
    });
}

export function setSpecialDetailsId(id) {
  return dispatch =>
    dispatch({
      type: "SPECIAL_SET_SPECIALDETAILSID",
      data: id,
    });
}
